import React from 'react'
import moment from 'moment'

function padTicket(value) {
    const stringValue = String(value || '')
    return stringValue.padStart(3, '0')
}

function backgroundValue(value) {
    if (!value) return 'url("")'
    const stringValue = String(value)
    if (stringValue.indexOf('url(') > -1 || stringValue.indexOf('gradient(') > -1) return stringValue
    return 'url("' + stringValue + '")'
}

function borderValue(value) {
    const stringValue = String(value || '').trim()
    if (!stringValue) return '1px solid #ffffff'
    if (stringValue.indexOf('solid') > -1) return stringValue
    return '1px solid ' + stringValue
}

function previewClientStyles(styles) {
    const source = styles || {}
    return {
        '--bodyTxt': source.bodyTxt || '#ffffff',
        '--livePrizePoolLabelBg': source.livePrizePoolLabelBg || '#ff0000',
        '--livePrizePoolLabelTxt': source.livePrizePoolLabelTxt || '#ffffff',
        '--primaryBtnBg': source.primaryBtnBg || '#ff0000',
        '--primaryBtnTxt': source.primaryBtnTxt || '#ffffff',
        '--secondaryBtnBorder': borderValue(source.secondaryBtnBorder),
        '--secondaryBtnTxt': source.secondaryBtnTxt || '#ffffff',
        '--splitPrizeBg': source.splitPrizeBg || '#ffffff',
        '--splitPrizeTxt': source.splitPrizeTxt || '#0000ff',
        '--ticketsSoldTxt': source.ticketsSoldTxt || '#ffcc00',
        '--background': backgroundValue(source.background),
        '--backgroundOverlayColor': source.backgroundOverlayColor || '#000000',
        '--backgroundOverlayOpacity': source.backgroundOverlayOpacity === undefined || source.backgroundOverlayOpacity === null ? 0 : source.backgroundOverlayOpacity,
        '--logoBg': source.logoBg || 'transparent'
    }
}

function logoImageStyle(styles) {
    const source = styles || {}
    return {
        transform: 'translate(' + ((Number(source.logoOffsetX || 0) * 100).toFixed(3)) + '%, ' + ((Number(source.logoOffsetY || 0) * 100).toFixed(3)) + '%) scale(' + Number(source.logoScale || 1) + ')',
        transformOrigin: 'center center'
    }
}

function previewSkinClass(styles) {
    const skin = styles && styles.skin ? styles.skin : 'classic'
    if (skin === 'spotlight') return 's50-preview s50-preview--spotlight'
    return 's50-preview s50-preview--classic'
}

function isSpotlightSkin(styles) {
    return styles && styles.skin === 'spotlight'
}

function fallbackEvent(client, event) {
    if (event) return event
    return {
        SK: client && client.currentEvent ? client.currentEvent : 'PREVIEW_001',
        prizePool: 0,
        maxPrizePool: Number(client && client.defaultMaxPrize ? client.defaultMaxPrize : 0),
        completed: false,
        pending: false,
        winningTicket: '-',
        drawDate: '',
        title: client && client.name ? client.name : '',
        license: ''
    }
}

class PublicDashboardPreview extends React.Component {
    _logoFrameClass(frame) {
        if (frame === 'circle') return 'rounded-full'
        if (frame === 'rounded') return 'rounded-[28px]'
        if (frame === 'square') return 'rounded-none'
        return ''
    }

    render() {
        const client = this.props.client || {}
        const event = fallbackEvent(client, this.props.event)
        const styles = previewClientStyles(client.styles)
        const scaleClass = this.props.scaleClassName || 'scale-[0.5]'
        const charityLabel = client.charityAlt ? client.charityAlt : client.charity
        const prizePool = Number(event.prizePool || 0)
        const halfPrize = (prizePool / 2).toFixed(2)
        const isCompleted = !!event.completed
        const isDrawPending = !!event.drawPending && !isCompleted
        const isPending = !!event.pending && !isCompleted && !isDrawPending
        const showChrome = this.props.showChrome !== false
        const logoFrame = client.styles && client.styles.logoFrame ? client.styles.logoFrame : 'none'
        const logoBg = client.styles && client.styles.logoBg ? client.styles.logoBg : ''
        const logoStyle = logoImageStyle(client.styles)
        const spotlightSkin = isSpotlightSkin(client.styles)

        return (
            <section className={showChrome ? 'rounded-[28px] border border-slate-200/70 bg-white/80 p-6 shadow-soft backdrop-blur dark:border-slate-800 dark:bg-slate-950/70' : ''}>
                {showChrome ?
                    <div className="flex items-center justify-between gap-4">
                        <div>
                            <h2 className="text-lg font-semibold text-slate-900 dark:text-white">Live preview</h2>
                            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">Scaled copy of the public dashboard using the same layout, copy, and style variables.</p>
                        </div>
                        <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:bg-slate-800 dark:text-slate-300">50%</span>
                    </div>
                    : null}

                <div className={(showChrome ? 'mt-6 ' : '') + 'overflow-hidden rounded-[28px] border border-slate-200 bg-slate-100 p-5 dark:border-slate-800 dark:bg-slate-900/80'}>
                    <div className="flex justify-center overflow-hidden">
                        <div className="s50-preview-viewport flex justify-center">
                            <div className={'origin-top ' + scaleClass}>
                                <div className={previewSkinClass(client.styles)} style={styles}>
                                    <div className="s50-preview__background">
                                        {client.styles && client.styles.hero ?
                                            <div className="s50-preview__hero">
                                                <img src={client.styles.hero} alt="hero" />
                                            </div>
                                            : null}
                                        <div className="s50-preview__background-overlay" />

                                        {!isCompleted ?
                                            isPending ?
                                                null
                                                :
                                            <div className="s50-preview__progress">
                                                <div className="s50-preview__progress-bar" />
                                            </div>
                                            : null}

                                        <div className="s50-preview__content-wrap">
                                            <div className="s50-preview__content">
                                                {client.styles && client.styles.logo ?
                                                    <div className={'s50-preview__logo-frame ' + this._logoFrameClass(logoFrame)} style={logoBg ? { background: logoBg } : null}>
                                                        <img src={client.styles.logo} className="s50-preview__logo" alt="logo" style={logoStyle} />
                                                    </div>
                                                    : null}

                                                {event.title && !isCompleted && !isPending ?
                                                    <h4 className="s50-preview__title s50-preview__title--red s50-preview__title--with-logo">{event.title}</h4>
                                                    : null}

                                                {isPending ?
                                                    <div>
                                                        <h4 className="s50-preview__title s50-preview__title--red">This event has not started</h4>
                                                    </div>
                                                    :
                                                    <>
                                                        <div className="s50-preview__chevron">
                                                            {isCompleted ? 'Final Prize Pool' : 'Live Prize Pool'}
                                                        </div>
                                                        <div className="s50-preview__prizepool">
                                                            <span>${prizePool.toFixed(2)}</span>
                                                        </div>
                                                        <div className="s50-preview__eventno">
                                                            <span>EVENT #{event.SK}</span>
                                                            {event.license ?
                                                                <>
                                                                    <br />
                                                                    <span>{event.license}</span>
                                                                </>
                                                                : null}
                                                        </div>
                                                    </>}

                                                {isPending ? null : isCompleted ?
                                                    <div>
                                                        <h4 className="s50-preview__title s50-preview__title--red">
                                                            {event.completeBeforeDraw
                                                                ? (event.completedAltText || 'This event has now completed.')
                                                                : ('This event has now completed and was drawn on ' + (event.endDate ? moment(event.endDate).format('DD/MM/YY') : '--/--/--') + ' at ' + (event.endDate ? moment(event.endDate).format('h:mma') : '--:--'))}
                                                        </h4>
                                                        {event.winningTicket && event.winningTicket !== '-' ?
                                                            <p className="s50-preview__copy">The winning ticket was {event.SK}_{padTicket(event.winningTicket)}</p>
                                                            : null}
                                                        <button className="s50-preview__button s50-preview__button--secondary">Check my Ticket</button>
                                                        <button className="s50-preview__button s50-preview__button--secondary s50-preview__button--spaced">Past Events</button>
                                                    </div>
                                                    :
                                                    <div>
                                                        {isDrawPending ?
                                                            <h4 className="s50-preview__title s50-preview__title--red">{event.completedAltText || 'This event has now completed and is awaiting the winner draw.'}</h4>
                                                            : event.altDrawMsg ?
                                                            <h4 className="s50-preview__title s50-preview__title--red">{event.altDrawMsg}</h4>
                                                            :
                                                            <h4 className="s50-preview__title s50-preview__title--red">
                                                                {'Winner drawn when prize pool reaches $' + Number(event.maxPrizePool || 0)}
                                                                {event.drawDate ? ' OR ON ' + moment(new Date(event.drawDate)).format('DD/MM/YY') + ' AFTER ' + moment(new Date(event.drawDate)).format('h:mma') : ''}
                                                            </h4>}
                                                        <p className="s50-preview__copy">
                                                            {client.altPromo ? client.altPromo : ('Buy a ticket to support ' + (client.charity || 'your cause') + ' and for your chance to win 50% of the final prize pool.')}
                                                        </p>
                                                        {spotlightSkin ?
                                                            <div className="s50-preview__spotlight-split">
                                                                <div className="s50-preview__box s50-preview__spotlight-panel s50-preview__spotlight-panel--winner">
                                                                    <h4>winner</h4>
                                                                    <span>${halfPrize}</span>
                                                                </div>
                                                                <div className="s50-preview__box s50-preview__spotlight-panel s50-preview__spotlight-panel--charity">
                                                                    <h4>{charityLabel || 'Charity'}</h4>
                                                                    <span>${halfPrize}</span>
                                                                </div>
                                                            </div>
                                                            :
                                                            <>
                                                                <div className="s50-preview__box">
                                                                    <h4>winner</h4>
                                                                    <span>${halfPrize}</span>
                                                                </div>
                                                                <div className="s50-preview__box s50-preview__box--charity-invert">
                                                                    <h4>{charityLabel || 'Charity'}</h4>
                                                                    <span>${halfPrize}</span>
                                                                </div>
                                                            </>}
                                                        {!isDrawPending ? <button className="s50-preview__button s50-preview__button--primary">Buy Tickets</button> : null}
                                                        <button className="s50-preview__button s50-preview__button--secondary">Check my Ticket</button>
                                                        <button className="s50-preview__button s50-preview__button--secondary s50-preview__button--spaced">Past Events</button>
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default PublicDashboardPreview
